import * as React from 'react'
import axios from 'axios'
import ggle from '../Assets/google.png'
import { Link } from 'react-router-dom'
const Signup = () => {

  return (
    <div className='flex flex-col bg-white justify-between items-center'>\
        <div className=' bg-white h-[100vh] w-[50vw] flex flex-col justify-center items-center'>
          <p className='font-bold text-black text-3xl p-5 text-left'>Sign up</p>
         <form className='form px-6 p-8  rounded-lg space-y-8 flex flex-col z-1 w-[80vw] md:w-[35vw]'>
           <input style={{ border:'1px solid gray' }} className='p-2 rounded-lg form-input' required  type='text' placeholder='Full Name'/>
           <input style={{ border:'1px solid gray' }} className='p-2 rounded-lg form-input' required  type='email' placeholder='Email'/>
           <input style={{ border:'1px solid gray' }} className='p-2 rounded-lg form-input' required type='password' placeholder='Password'/>
           <input style={{ border:'1px solid gray' }} className='p-2 rounded-lg form-input' required  type='password' placeholder='Confirm Password'/>
           <Link to='/' className=''>
           <p  className='mt-6 font-bold text-white w-auto text-center bg-gray-800 rounded-lg p-2 cursor-pointer'>Register</p>
           </Link>
           <div  className='flex justify-center items-center space-x-4 form-input mt-6 font-bold  w-auto text-center rounded-lg p-2 cursor-pointer'>
             <img width={25} className='mx-2' src={ggle} alt='google'/>
             Continue with Google
            </div>
            <Link to='/login' className=''>
             <p  className='mt-6 font-bold  w-auto text-center  rounded-lg p-2 '>Already Have an account? <span className='cursor-pointer text-cyan-600'>Login</span></p>
            </Link>
         </form>
        </div>
      
    </div>
  )
}

export default Signup